(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-story-section"] && !Shopify.designMode) return;
  try {
    
  // 滾動觸發動畫
  const observerOptions = {
    threshold: 0.2,
    rootMargin: '0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  // 監聽所有需要動畫的元素
  document.addEventListener('DOMContentLoaded', () => {
    const animatedElements = document.querySelectorAll('.timeline-item, .story-header');
    animatedElements.forEach(el => {
      observer.observe(el);
    });
  });

  // 視差滾動效果
  window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const section = document.querySelector('.brand-story-section');
    
    if (section) {
      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        const parallaxSpeed = 0.3;
        const yPos = -(scrolled * parallaxSpeed);
        section.style.backgroundPosition = `center ${yPos}px`;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-totals"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const wrapper = document.querySelector('[data-section-type="cart-totals"]');
    if (!wrapper) return;

    // 防止重複初始化
    const FLAG = wrapper.dataset.initFlag;
    if (window[FLAG]) return;
    window[FLAG] = true;

    const sid = wrapper.dataset.sectionId;
    const contentId = wrapper.dataset.contentId;

    // 小工具：每次都取最新的 content 容器
    const getContentEl = () => document.getElementById(contentId);

    // 去抖：把頻繁的事件合併
    let tmr;
    const debounce = (fn, delay = 180) => {
      clearTimeout(tmr);
      tmr = setTimeout(fn, delay);
    };

    // 用 routes.root 支援多語系/子路徑
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    function htmlToNode(html) {
      const dom = new DOMParser().parseFromString(html, 'text/html');
      return dom.getElementById(contentId);
    }

    function refreshTotals() {
      // 先試新版 ?sections=
      const u1 = new URL(window.location.href);
      u1.pathname = root.replace(/\/$/, '') + u1.pathname.replace(root.replace(/\/$/, ''), '');
      u1.searchParams.set('sections', sid);

      fetch(u1.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(r => r.ok ? r.json() : Promise.reject())
        .then(json => {
          const html = json && json[sid];
          if (!html) throw new Error('Sections JSON missing');
          const freshContent = htmlToNode(html);
          const contentEl = getContentEl();
          if (freshContent && contentEl) {
            contentEl.replaceWith(freshContent);
          }
        })
        .catch(() => {
          // 舊法 fallback: ?section_id=
          const u2 = new URL(window.location.href);
          u2.pathname = root.replace(/\/$/, '') + u2.pathname.replace(root.replace(/\/$/, ''), '');
          u2.searchParams.set('section_id', sid);

          fetch(u2.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(r => r.text())
            .then(html => {
              const freshContent = htmlToNode(html);
              const contentEl = getContentEl();
              if (freshContent && contentEl) {
                contentEl.replaceWith(freshContent);
              }
            })
            .catch(() => {
              console.error('Failed to refresh totals');
            });
        });
    }

    // —— A: 主題/外掛可能丟的事件 —— //
    [
      'cart:updated','cart:change','cart:refresh','quantity:change',
      'product:added','cart:item:added','cart:item:updated','cart:item:removed'
    ].forEach(evt => document.addEventListener(evt, () => debounce(() => refreshTotals(), 240)));

    // —— B: 攔截 cart 相關的 fetch / XHR —— //
    const _fetch = window.fetch;
    window.fetch = function(...args){
      return _fetch.apply(this, args).then(res => {
        try {
          const u = String(args[0]||'');
          if (u.includes('/cart') || u.includes('/add') || u.includes('cart/add')) {
            debounce(() => refreshTotals(), 260);
          }
        } catch(e){}
        return res;
      });
    };

    const _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(m, u, ...rest) {
      this.addEventListener('load', function(){
        try {
          const s = String(u||'');
          if (s.includes('/cart') || s.includes('/add') || s.includes('cart/add')) {
            debounce(() => refreshTotals(), 260);
          }
        } catch(e){}
      });
      return _open.apply(this, [m, u, ...rest]);
    };

    // —— C: 鏡像原生 summary（你是隱藏不是移除） —— //
    const nativeTotal = document.querySelector(
      '.cart-page__summary [data-cart-subtotal], .cart-page__summary .cart__total .cart__total-value'
    );
    if (nativeTotal) {
      const sync = () => {
        const mine = document.querySelector('#' + contentId + ' [data-cart-subtotal]');
        if (!mine) return;
        const t = (nativeTotal.textContent||'').trim();
        if (t && t !== (mine.textContent||'').trim()) {
          mine.textContent = t;
          mine.setAttribute('value', t);
        }
      };
      const mo = new MutationObserver(sync);
      mo.observe(nativeTotal, { characterData:true, childList:true, subtree:true });
      sync();
    }

    // 初始化先跑一次（給首次進頁或快取）
    document.addEventListener('DOMContentLoaded', () => refreshTotals());
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinematic-video-section"] && !Shopify.designMode) return;
  try {
    
  class CinematicVideoController {
    constructor(){
      this.video = document.getElementById('brandVideo');
      this.playControl = document.getElementById('playControl');
      this.statusIndicator = document.getElementById('statusIndicator');
      this.progressBar = document.getElementById('progressBar');
      this.loadingRing = document.getElementById('loadingRing');
      this.hasPlayed = false;
      this.init();
      this.createParticles();
    }

    init(){
      this.setupIntersectionObserver();
      this.setupVideoEvents();
      this.setupPlayControl();
    }

    createParticles(){
      const canvas=document.getElementById('particleCanvas');
      const count=window.innerWidth<768?8:15;
      for(let i=0;i<count;i++){
        const p=document.createElement('div');
        p.className='floating-particle';
        p.style.left=Math.random()*100+'%';
        p.style.animationDelay=Math.random()*20+'s';
        p.style.animationDuration=(15+Math.random()*10)+'s';
        canvas.appendChild(p);
      }
    }

    setupIntersectionObserver(){
      const observer=new IntersectionObserver((entries)=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting && !this.hasPlayed){
            this.autoPlay();
          }
        });
      },{threshold:.1,rootMargin:'100px 0px -50px 0px'});
      observer.observe(this.video);
    }

    setupVideoEvents(){
      this.video.addEventListener('loadeddata',()=>{this.loadingRing.classList.add('hide');});
      this.video.addEventListener('play',()=>{this.statusIndicator.classList.add('active');this.playControl.classList.remove('show');});
      this.video.addEventListener('pause',()=>{this.statusIndicator.classList.remove('active');this.playControl.classList.add('show');});
      this.video.addEventListener('ended',()=>{this.statusIndicator.classList.remove('active');this.playControl.classList.add('show');this.progressBar.style.width='0%';});
      this.video.addEventListener('timeupdate',()=>{if(this.video.duration){this.progressBar.style.width=(this.video.currentTime/this.video.duration)*100+'%';}});
      this.video.addEventListener('error',()=>{this.loadingRing.classList.add('hide');this.playControl.classList.add('show');});
    }

    setupPlayControl(){
      this.playControl.addEventListener('click',()=>{this.playVideo();});
    }

    async autoPlay(){
      try{this.video.muted=false;await this.video.play();this.hasPlayed=true;}
      catch(err){
        try{this.video.muted=true;await this.video.play();this.hasPlayed=true;}catch(e){this.playControl.classList.add('show');}
      }
    }

    async playVideo(){
      try{
        if(this.video.ended){this.video.currentTime=0;}
        this.video.muted=false;
        await this.video.play();
        this.hasPlayed=true;
      }catch(err){console.error('播放失敗',err);}
    }
  }

  document.addEventListener('DOMContentLoaded',()=>{new CinematicVideoController();});
  document.addEventListener('visibilitychange',()=>{const v=document.getElementById('brandVideo');if(document.hidden && !v.paused){v.pause();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coating-products-section"] && !Shopify.designMode) return;
  try {
    
  // 產品 ID 配置 - 只需要替換為您的實際產品 ID
    const productIds = {
      'titanium-coating': '9034349379835',  // 請替換為您實際的產品 ID
      'atomic-aurora': 'YOUR_PRODUCT_ID_2', 
      'atomic-glaze': 'YOUR_PRODUCT_ID_3',
      'atomic-microcrystal': 'YOUR_PRODUCT_ID_4',
      'atomic-sealant': 'YOUR_PRODUCT_ID_5',
      'atomic-basic': 'YOUR_PRODUCT_ID_6'
    };

    // 使用產品 ID 直接跳轉到產品頁面
    function goToProduct(productKey) {
      console.log('產品 ID:' + productKey);
      const productId = productIds[productKey];
      if (productId) {
        // 先取得產品資料來獲取正確的 handle
        fetch(`/products/${productId}.js`)
          .then(response => response.json())
          .then(product => {
            // 直接跳轉到產品頁面
            window.location.href = `/products/${product.handle}`;
          })
          .catch(error => {
            console.error('跳轉失敗:', error);
            // 備用方案：使用產品 ID 進行搜尋
            window.location.href = `/search?q=id:${productId}`;
          });
      } else {
        console.error('找不到產品 ID:', productKey);
      }
    }

    // 滾動指示器邏輯
    document.addEventListener('DOMContentLoaded', function() {
      const scroller = document.getElementById('productScroller');
      const dots = document.querySelectorAll('.scroll-dot');
      
      if (scroller && dots.length > 0) {
        // 更新滾動指示器
        function updateScrollIndicator() {
          const scrollLeft = scroller.scrollLeft;
          const scrollWidth = scroller.scrollWidth - scroller.clientWidth;
          const scrollPercentage = scrollLeft / scrollWidth;
          
          // 根據滾動位置計算當前應該高亮的點
          const activeIndex = Math.round(scrollPercentage * (dots.length - 1));
          
          dots.forEach((dot, index) => {
            if (index === activeIndex) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        }
        
        // 監聽滾動事件
        scroller.addEventListener('scroll', updateScrollIndicator);
        
        // 初始化
        updateScrollIndicator();
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero-section"] && !Shopify.designMode) return;
  try {
    
function handleConsultClick(){
  console.log('開啟專員諮詢服務');
  alert('即將為您開啟專員諮詢服務！');
}
function handleStoreClick(){
  console.log('開啟店鋪查詢功能');
  alert('即將為您開啟店鋪查詢功能！');
}
document.addEventListener('DOMContentLoaded',function(){
  const titleElements=document.querySelectorAll('.fade-in-up');
  titleElements.forEach((el,i)=>{setTimeout(()=>{el.classList.add('animate');},200+i*150);});
  const assistanceCards=document.querySelectorAll('.fade-in-left');
  assistanceCards.forEach((card,i)=>{setTimeout(()=>{card.classList.add('animate');},600+i*200);});
});
function switchToImageTitle(imagePath){
  const title=document.querySelector('.page-title');
  title.classList.add('image-title');
  title.style.backgroundImage=`url('${imagePath}')`;
  if(!document.querySelector('.sr-only')){
    const srText=document.createElement('span');
    srText.className='sr-only';
    srText.textContent=title.textContent+' - APGO專業汽車鍍膜';
    title.parentNode.appendChild(srText);
  }
}
window.addEventListener('resize',function(){});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-section"] && !Shopify.designMode) return;
  try {
    
  // 進度條進場動畫
  document.addEventListener('DOMContentLoaded',function(){
    const bars=document.querySelectorAll('.bar-fill');
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){
          bars.forEach((bar,i)=>{
            const width=bar.style.width;
            bar.style.width='0';
            setTimeout(()=>{bar.style.width=width;},100+i*100);
          });
          observer.disconnect();
        }
      });
    });
    const section=document.querySelector('.comparison-section');
    if(section)observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
  // JS 行為：滾動指示器、視差效果、鍵盤支援
  document.addEventListener('DOMContentLoaded', function () {
    const indicator = document.querySelector('.scroll-indicator');
    if (indicator) {
      indicator.addEventListener('click', function () {
        window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
      });
    }

    window.addEventListener('scroll', function () {
      const scrolled = window.pageYOffset;
      const heroImage = document.querySelector('.hero-image');
      const scrollIndicator = document.querySelector('.scroll-indicator');
      const parallaxSpeed = 0.5;
      if (heroImage && scrolled < window.innerHeight) {
        heroImage.style.transform = `scale(1.05) translateY(${scrolled * parallaxSpeed}px)`;
      }
      if (scrollIndicator) {
        if (scrolled > 100) {
          scrollIndicator.classList.add('hide');
        } else {
          scrollIndicator.classList.remove('hide');
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === ' ') {
        e.preventDefault();
        window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["livestream-stats-section"] && !Shopify.designMode) return;
  try {
    
  // 創建愛心的函數
  function createHeart(container) {
    const heart = document.createElement('div');
    const colors = ['heart-red', 'heart-pink', 'heart-orange', 'heart-yellow', 'heart-purple'];
    const paths = ['heart-path-1', 'heart-path-2', 'heart-path-3', 'heart-path-4'];
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    const randomPath = paths[Math.floor(Math.random() * paths.length)];

    heart.className = `heart ${randomColor} ${randomPath}`;

    // 固定在右側，稍微有一點隨機偏移
    const randomOffset = Math.random() * 10 - 5; // -5 到 +5 的偏移
    heart.style.right = 30 + randomOffset + 'px';

    // 隨機大小
    const randomScale = 0.85 + Math.random() * 0.3;
    heart.style.transform = `rotate(-45deg) scale(${randomScale})`;

    // 隨機動畫時長（增加變化）
    const randomDuration = 4 + Math.random() * 2;
    heart.style.animationDuration = randomDuration + 's';

    container.appendChild(heart);

    // 動畫結束後移除
    setTimeout(() => {
      heart.remove();
    }, randomDuration * 1000);
  }

  // 持續生成愛心
  function startHeartAnimation() {
    const activeWrapper = document.querySelector('.team-image-wrapper.active');
    if (activeWrapper) {
      const heartsContainer = activeWrapper.querySelector('.hearts-container');
      if (heartsContainer) {
        createHeart(heartsContainer);
      }
    }
  }

  // 每隔一段時間生成愛心
  let heartInterval = setInterval(startHeartAnimation, 800);

  // 分頁切換功能
  function initTabSwitching() {
    const tabButtons = document.querySelectorAll('.tab-button');
    const teamImages = document.querySelectorAll('.team-image-wrapper');
    const taiwanVideo = document.querySelector('#taiwan-team .team-video');
    const sgMyVideo = document.querySelector('#sg-my-team .team-video');

    // 手動切換功能
    tabButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // 移除所有 active 類
        tabButtons.forEach((btn) => btn.classList.remove('active'));
        teamImages.forEach((img) => img.classList.remove('active'));

        // 添加 active 類到點擊的按鈕
        this.classList.add('active');

        // 顯示對應的圖片
        const teamType = this.dataset.team;
        const targetImage = document.getElementById(`${teamType}-team`);
        if (targetImage) {
          targetImage.classList.add('active');
        }

        // 暫停非活動影片，播放活動影片
        if (teamType === 'taiwan') {
          taiwanVideo.play();
          sgMyVideo.pause();
          sgMyVideo.currentTime = 0;
        } else {
          sgMyVideo.play();
          taiwanVideo.pause();
          taiwanVideo.currentTime = 0;
        }
      });
    });

    // 自動切換功能 - 當台灣影片播放結束時
    if (taiwanVideo) {
      taiwanVideo.addEventListener('ended', function () {
        // 切換到新馬團隊
        const sgMyButton = document.querySelector('[data-team="sg-my"]');
        const taiwanButton = document.querySelector('[data-team="taiwan"]');

        // 更新按鈕狀態
        taiwanButton.classList.remove('active');
        sgMyButton.classList.add('active');

        // 切換影片
        document.getElementById('taiwan-team').classList.remove('active');
        document.getElementById('sg-my-team').classList.add('active');

        // 播放新馬影片
        sgMyVideo.currentTime = 0;
        sgMyVideo.play();
      });
    }

    // 當新馬影片播放結束時，切回台灣影片
    if (sgMyVideo) {
      sgMyVideo.addEventListener('ended', function () {
        // 切換回台灣團隊
        const sgMyButton = document.querySelector('[data-team="sg-my"]');
        const taiwanButton = document.querySelector('[data-team="taiwan"]');

        // 更新按鈕狀態
        sgMyButton.classList.remove('active');
        taiwanButton.classList.add('active');

        // 切換影片
        document.getElementById('sg-my-team').classList.remove('active');
        document.getElementById('taiwan-team').classList.add('active');

        // 播放台灣影片
        taiwanVideo.currentTime = 0;
        taiwanVideo.play();
      });
    }
  }

  // 數字跳動動畫
  function animateNumbers() {
    const numbers = document.querySelectorAll('.stat-number');

    numbers.forEach((number, index) => {
      const target = parseInt(number.getAttribute('data-target'));
      const duration = 2000;
      const increment = target / (duration / 16);
      let current = 0;

      // 延遲啟動，創造依序動畫效果
      setTimeout(() => {
        const updateNumber = () => {
          current += increment;
          if (current < target) {
            number.textContent = formatNumber(Math.floor(current));
            number.classList.add('counting');
            setTimeout(() => number.classList.remove('counting'), 100);
            requestAnimationFrame(updateNumber);
          } else {
            number.textContent = formatNumber(target);
          }
        };
        updateNumber();
      }, index * 200);
    });
  }

  // 格式化數字（添加千分位）
  function formatNumber(num) {
    if (num >= 1000000) {
      return Math.floor(num / 10000) + '萬';
    } else if (num >= 10000) {
      return (num / 10000).toFixed(0) + '萬';
    }
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Intersection Observer 監聽元素進入視窗
  const observerOptions = {
    threshold: 0.3,
    rootMargin: '0px',
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateNumbers();
        observer.disconnect();
      }
    });
  }, observerOptions);

  // 開始觀察
  document.addEventListener('DOMContentLoaded', () => {
    initTabSwitching();

    const section = document.querySelector('.stats-showcase');
    if (section) {
      observer.observe(section);
    }
  });

  // CTA按鈕波紋效果
  document.querySelector('.cta-button').addEventListener('click', function (e) {
    const ripple = document.createElement('span');
    const rect = this.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;

    ripple.style.cssText = `
                position: absolute;
                width: ${size}px;
                height: ${size}px;
                border-radius: 50%;
                background: rgba(255, 255, 255, 0.5);
                left: ${x}px;
                top: ${y}px;
                pointer-events: none;
                transform: scale(0);
                animation: rippleEffect 0.6s ease-out;
            `;

    this.appendChild(ripple);
    setTimeout(() => ripple.remove(), 600);
  });

  // 添加波紋動畫樣式
  const style = document.createElement('style');
  style.textContent = `
            @keyframes rippleEffect {
                to {
                    transform: scale(4);
                    opacity: 0;
                }
            }
        `;
  document.head.appendChild(style);

  // 清理定時器（當頁面關閉時）
  window.addEventListener('beforeunload', () => {
    clearInterval(heartInterval);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
